export const CheckPosition = (position) => {
    if(position && position?.length !== 0) {
        let ArrPosition = []
        position?.map((item) => {
            switch (item?.position_id) {
                case 1:
                    ArrPosition.push(1)
                    // console.log("admin")
                    break;
                case 2:
                    ArrPosition.push(2)
                    // console.log("เลขา")
                    break;
                case 3:
                    ArrPosition.push(3)
                    // console.log("รองเลขา")
                    break;
                case 4:
                    ArrPosition.push(4)
                    // console.log("ผู้ช่วยเลขาธิการ")
                    break;
                case 5:
                    ArrPosition.push(5)
                    // console.log("ผอ.กอง")
                    break;
                case 6:
                    ArrPosition.push(6)
                    // console.log("ผู้เชี่ยวชาญกอง")
                    break;
                case 7:
                    ArrPosition.push(7)
                    // console.log("หัวหน้ากลุ่ม")
                    break;
                // case 8:
                //     ArrPosition.push(8)
                //     // console.log("เจ้าหน้าที่")
                //     break;
            }
        })
        return ArrPosition
    } else {
        return false
    }
}